import { jsx as e, jsxs as t, Fragment as a } from "react/jsx-runtime";

import r from "@ui-components-3/ui/lib/components/Drawer";

import { useForm as o, FormProvider as l, useFormContext as n } from "react-hook-form";

import i from "@ui-components-3/ui/lib/hooks/useId";

import s from "@ui-components-3/icons/lib/regular/ArrowRight";

import { useCreateAvailabilityFlow as m } from "../../hooks/useCreateAvailability.js";

import u from "../hook-form/FormDateTimePicker.js";

import { useMemo as c, useCallback as d, useEffect as f } from "react";

import { yupResolver as p } from "@hookform/resolvers/yup";

import { DateRangeAndRepeatFormSchema as h, getAvailabilityFrequencyLabel as b, AVAILABILITY_FREQUENCY_OPTIONS as D, getWeeklyIntervalLabel as v, WEEKLY_INTERVAL_OPTIONS as w, AVAILABILITY_FREQUENCIES_MAP as y } from "../../schemas.js";

import x from "../hook-form/FormSelect.js";

import N from "@ui-components-3/ui/lib/utils/classNames";

import { useProviderSchedule as S } from "../../hooks/useProviderSchedule.js";

import { SCHEDULE_DATE_FORMAT as g } from "../../utils.js";

import { startOfDay as O, format as k, addDays as j, addMonths as q, parse as R, endOfDay as V } from "date-fns";

import C from "@ui-components-3/ui/lib/components/Notice";

const T = () => {
    const o = i(), {resetFlow: l, saveDateRangeAndRepeat: c, editableSchedule: p} = m(), {variantClassNames: h} = S(), {watch: k, handleSubmit: T, setValue: A, formState: {errors: E, isValid: F}} = n(), [M, L, P] = k([ "startDate", "endDate", "frequency" ]), B = d(((e, t) => {
        A(e, t, {
            shouldDirty: !0,
            shouldTouch: !0,
            shouldValidate: !0
        });
    }), [ A ]), I = P === y.weekly, z = "dailyEndDate" === E?.frequency?.type;
    // We need to validate and touch endDate each time both dates are changed
    // to make sure end date is later than start date and display/clear validation error
    // react-hook-form does not allow just to touch field, so to trigger touch we need to set value again with shouldTouch: true
    f((() => {
        if (M && L && P) {
            const e = setTimeout((() => {
                B("endDate", L), B("frequency", P);
            }), 100);
            return () => {
                clearTimeout(e);
            };
        }
    }), [ L, B, M, P, z ]), f((() => {
        I || B("interval", null);
    }), [ I, B ]);
    const G = d((e => {
        const t = O(new Date(e)).valueOf(), a = [ O(new Date).valueOf() ];
        return L && a.push(j(q(O(R(L, g, new Date)), -3), 1).valueOf()), t < Math.max(...a);
    }), [ L ]), H = d((e => {
        const t = V(new Date(e)).valueOf();
        let a = null, r = V(new Date).valueOf();
        return M && (a = j(q(V(R(M, g, new Date)), 3), -1).valueOf(), r = V(R(M, g, new Date)).valueOf()), 
        !!a && t > a || t < r;
    }), [ M ]);
    return t(a, {
        children: [ e(r.Content, {
            children: t("form", {
                className: "flex flex-col gap-4 py-4",
                id: o,
                onSubmit: T(c),
                children: [ e("p", {
                    className: N("typography-body-xl py-3 font-semibold", h.textMain),
                    children: "Step 1: Set date range and repeat"
                }), t("div", {
                    className: "flex flex-row flex-wrap gap-4",
                    children: [ e(u, {
                        name: "startDate",
                        label: "Start Date*",
                        className: "min-w-[210px] flex-1",
                        isDateDisabled: G
                    }), e(u, {
                        name: "endDate",
                        label: "End Date*",
                        className: "min-w-[210px] flex-1",
                        variant: z ? "error" : void 0,
                        isDateDisabled: H
                    }) ]
                }), e(x, {
                    name: "frequency",
                    label: "Repeat*",
                    defaultValue: "Select...",
                    options: D,
                    getOptionLabel: b,
                    disabled: !!p,
                    shouldShowError: !!z
                }), !!I && e(x, {
                    name: "interval",
                    label: "Repeats Every*",
                    defaultValue: "Select...",
                    options: w,
                    getOptionLabel: v,
                    disabled: !!p
                }), !!p && e(C, {
                    variant: "info",
                    className: "!items-center",
                    children: e("p", {
                        className: "typography-small mt-1 font-normal text-neutral-800",
                        children: "To change the frequency, delete and create a new recurrence."
                    })
                }) ]
            })
        }), t(r.Footer, {
            children: [ e("button", {
                type: "button",
                className: N("btn", h.buttonOutlined),
                onClick: l,
                children: "Back"
            }), t("button", {
                type: "submit",
                form: o,
                className: N("btn", h.buttonMain),
                disabled: !F,
                children: [ "Next", e(s, {
                    "aria-hidden": "true"
                }) ]
            }) ]
        }) ]
    });
}, A = () => {
    const {dateRangeAndRepeatValues: t, editableSchedule: a} = m(), {startDate: r, endDate: n, frequency: i, interval: s} = a || {}, u = c((() => {
        const e = r ? Math.max(O(new Date(r)).valueOf(), O(new Date).valueOf()) : null;
        return {
            startDate: e ? k(new Date(e), g) : null,
            endDate: n ? k(new Date(n), g) : null,
            frequency: i ? i.toLowerCase() : null,
            interval: s || null,
            ...t
        };
    }), [ t, n, i, s, r ]), d = o({
        resolver: p(h),
        mode: "all",
        defaultValues: u
    });
    return e(l, {
        ...d,
        children: e(T, {})
    });
};

export { A as default };
//# sourceMappingURL=DateRangeAndRepeatStepContent.js.map
